import React, { useState, useEffect } from 'react';
import { COLORS } from '../../styles/tokens';

export const LOCATION_TOAST_MS = 6000;

// Midlertidig melding over kartet når posisjonen ikke kunne hentes. Vises bare mens `active` er sant
// (ingen tidligere posisjon å bruke), forsvinner av seg selv etter 6 sekunder og kan lukkes.
// Flyter over kartet, så innholdet under ikke flytter seg.
export default function LocationToast({ active, message = 'Fikk ikke posisjonen din. Viser Oslo sentrum.', duration = LOCATION_TOAST_MS, style }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!active) { setVisible(false); return undefined; }
    setVisible(true);
    const id = setTimeout(() => setVisible(false), duration);
    return () => clearTimeout(id);
  }, [active, duration]);

  if (!visible) return null;
  return (
    <div role="status" aria-live="polite" style={{ ...styles.toast, ...style }}>
      <span style={{ flex: 1 }}>📍 {message}</span>
      <button type="button" onClick={() => setVisible(false)} aria-label="Lukk melding" style={styles.close}>✕</button>
    </div>
  );
}

const styles = {
  toast: {
    position: 'absolute', zIndex: 400,
    display: 'flex', alignItems: 'center', gap: 8,
    background: COLORS.warningBg, border: `1px solid ${COLORS.warningBorder}`, borderRadius: 12,
    padding: '6px 6px 6px 12px', fontSize: 12, color: COLORS.warningText,
    boxShadow: '0 1px 6px rgba(0,0,0,0.15)',
  },
  close: {
    flexShrink: 0, width: 28, height: 28, borderRadius: 14, border: 'none', background: 'transparent',
    color: 'inherit', fontSize: 13, lineHeight: 1, cursor: 'pointer',
  },
};
